/**
 * Scroll to Section — Global Handler
 * 
 * Handles all buttons with data-scroll-to-section attribute.
 * 
 * Usage in Liquid:
 *   <a href="#" data-scroll-to-section="{{ section.settings.scroll_target_id }}">...</a>
 * 
 * The value of data-scroll-to-section can be:
 *   - A CSS selector:        "#my-section-id", ".my-class"
 *   - A Shopify section ID:  "shopify-section-my-section-id"
 *   - A plain section name:  "customer-reviews" (will try multiple selector patterns)
 *   - "top"                  Scrolls to the very top of the page
 *   - "product"              Scrolls to the main product section
 *   - "add-to-cart"          Scrolls to the Add to Cart button
 */

(function () {
  'use strict';

  var OFFSET = 80; // px offset from top (accounts for sticky header)

  function getScrollOffset() {
    // Try to detect sticky header height dynamically
    var stickyHeader = document.querySelector(
      '.shopify-section-header-sticky, .header--sticky, [data-sticky-header], .sticky-header, #shopify-section-header'
    );
    if (stickyHeader) {
      var rect = stickyHeader.getBoundingClientRect();
      if (rect.height > 0) return rect.height + 16;
    }
    return OFFSET;
  }

  function smoothScrollTo(element) {
    if (!element) return;
    var offset = getScrollOffset();
    var top = element.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  function findTarget(value) {
    if (!value || value === '') return null;

    // Special keywords
    if (value === 'top') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return 'handled';
    }
    if (value === 'product') {
      var product = document.querySelector(
        '.shopify-section .product, [data-section-type="product"], .product-template, #ProductSection, .product-section, .main-product'
      );
      return product;
    }
    if (value === 'add-to-cart') {
      var atc = document.querySelector(
        'button[name="add"], .product-form__submit, [data-add-to-cart], .btn-add-to-cart, #AddToCart'
      );
      return atc;
    }

    // Direct CSS selector (starts with # or .)
    if (value.charAt(0) === '#' || value.charAt(0) === '.') {
      try { return document.querySelector(value); } catch (e) {}
    }

    // Try as a Shopify section wrapper ID
    var el = document.getElementById('shopify-section-' + value);
    if (el) return el;

    // Try as a plain ID
    el = document.getElementById(value);
    if (el) return el;

    // Try as a data-section-id attribute
    el = document.querySelector('[data-section-id="' + value + '"]');
    if (el) return el;

    // Try as a section type class (Shopify adds class="shopify-section" on wrappers)
    el = document.querySelector('.shopify-section[id*="' + value + '"]');
    if (el) return el;

    // Try as a partial class match
    try {
      el = document.querySelector('[class*="' + value + '"]');
      if (el) return el;
    } catch (e) {}

    return null;
  }

  function handleScrollClick(event) {
    var btn = event.currentTarget;
    var target = btn.getAttribute('data-scroll-to-section');
    if (!target) return;

    event.preventDefault();

    var result = findTarget(target.trim());
    if (result === 'handled') return; // already scrolled (top)
    if (result) {
      smoothScrollTo(result);
    } else {
      console.warn('[scroll-to-section] Could not find target: "' + target + '"');
    }
  }

  function attachListeners() {
    var buttons = document.querySelectorAll('[data-scroll-to-section]');
    buttons.forEach(function (btn) {
      // Avoid double-binding
      if (btn.getAttribute('data-scroll-bound') === 'true') return;
      btn.setAttribute('data-scroll-bound', 'true');
      btn.addEventListener('click', handleScrollClick);
    });
  }

  // Initial bind
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachListeners);
  } else {
    attachListeners();
  }

  // Re-bind after Shopify section re-renders (theme editor)
  document.addEventListener('shopify:section:load', function () {
    // Reset bound flags so new buttons get bound
    document.querySelectorAll('[data-scroll-bound="true"]').forEach(function (el) {
      el.removeAttribute('data-scroll-bound');
    });
    attachListeners();
  });

  // Expose globally so other scripts can trigger it
  window.scrollToSection = function (value) {
    var result = findTarget(value);
    if (result === 'handled') return;
    if (result) smoothScrollTo(result);
  };

})();
